export const RETAIL__BULK_UPDATE_LOCATION = 'RETAIL__BULK_UPDATE_LOCATION'